import { useMemo } from 'react';
import axios from 'axios';
import { useAuth } from 'react-oidc-context';

const useAxios = () => {
  const auth = useAuth();

  const client = useMemo(() => {
    const token = auth.user?.access_token;
    axios.defaults.headers.common['Authorization'] = token
      ? `Bearer ${token}`
      : '';
    return axios.create();
  }, [auth]);

  return client;
};

export default useAxios;
